export default (value: string) => {
  return /,/gi.test(value);
};
